<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <div class="mt-4 text-center">
      <BaseCard heading="Asignación Múltiple de Campamento">
        <v-card-text>
          <v-row>
            <!-- <v-col lg="5" md="5" sm="4" class="col-12">
              <v-select :items="aldeOpciones" v-model="aldea" label="Seleccione Aldea" outlined></v-select>
            </v-col>
            <v-col lg="5" md="5" sm="4" class="col-12">
              <v-select :items="carpaOpciones" v-model="carpa" label="Seleccione Carpa" outlined></v-select>
            </v-col> -->
            <v-spacer></v-spacer>
            <v-col v-if="showEliminar" lg="1" md="1" sm="1" class="col-12">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn small v-on="on" fab dark color="red" @click="deleteDuplicados()">
                    <v-icon small dark>fas fa-trash</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar Duplicados</span>
              </v-tooltip>
            </v-col>
            <v-col lg="1" md="1" sm="1" class="col-12">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn small v-on="on" fab dark color="primary" @click="openDialogUpload()">
                    <v-icon small dark>fas fa-cloud-upload-alt</v-icon>
                  </v-btn>
                </template>
                <span>Importar</span>
              </v-tooltip>
            </v-col>
            <v-col lg="1" md="1" sm="1" class="col-12">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn small v-on="on" fab dark color="primary" @click="openDialog()">
                    <v-icon small dark>fas fa-users</v-icon>
                  </v-btn>
                </template>
                <span>Asignar Empleados</span>
              </v-tooltip>
            </v-col>
            <EmpleadosListado
              ref="empleadolista"
              :selected="false"
              :dialog="dialog"
              @asignarEmpleados="asignarEmpleados($event)"
              @cancelar="cancelarDialogo()"
            ></EmpleadosListado>
          </v-row>
          <v-row>
            <v-col lg="12" md="12" sm="12" class="col-12">
              <v-data-table
                :headers="asignadoTabla"
                :items="empleadosAsignadosCampamento"
                class="border"
                multi-sort
                :mobile-breakpoint="0"
                :items-per-page="10"
                :item-class="row_classes"
                no-results-text="No se encontraron datos"
                no-data-text="No se encontraron datos"
              >
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="cancelar()">Cerrar</v-btn>
          <v-btn color="info" submit @click="guardar()">Guardar</v-btn>
        </v-card-actions>
      </BaseCard>
    </div>
    <v-dialog v-model="dialogUpload" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">Importar</v-card-title>
        <div class="px-5">
          <v-file-input
            show-size
            label="Archivo"
            accept=".xlsx,.xls,.csv"
            truncate-length="50"
            @change="changeFileUpload"
          ></v-file-input>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="closeDialogUpload">Cancelar</v-btn>
          <v-btn color="primary" text @click="acceptDialogUpload">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogLoading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          <p class="pt-3">Asignando unidades de campamento automáticamente</p>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ text }}
      <v-btn color="info" text @click="snackbar = false">
        Cerrar
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import AsignacionService from '@/CYC/campamento/asignacion/services/AsignacionService';
/*import moment from 'moment';*/
import XLSX from 'xlsx';

export default {
  name: 'AsignacionMultiple',
  components: {
    EmpleadosListado: () => import('./EmpleadosListado')
  },
  data: () => ({
    asignacionService: null,
    fileUpload: null,
    showEliminar: false,
    dialog: false,
    dialogLoading: false,
    dialogUpload: false,
    snackbar: false,
    timeout: 3000,
    text: '',
    page: {
      title: 'Campamento'
    },
    breadcrumbs: [
      {
        text: 'Asignación de Empleados',
        disabled: true
      },
      {
        text: 'Lista de Empleados Asignados',
        disabled: true
      },
      {
        text: 'Asignar',
        disabled: true
      }
    ],
    formValid: true,
    asignadoTabla: [
      { text: 'idtrabajador', value: 'idtrabajador', width: 150 },
      { text: 'nombres', value: 'nombres', width: 400 },
      { text: 'planilla', value: 'planilla', width: 150 },
      { text: 'sexo', value: 'sexo', width: 150 },
      { text: 'tipocampamento', value: 'tipocampamento', width: 200 },
      { text: 'sectorpadre', value: 'sectorpadre', width: 150 },
      { text: 'sector', value: 'sector', width: 150 },
      { text: 'aldea', value: 'aldea', width: 150 },
      { text: 'carpa', value: 'carpa', width: 150 },
      { text: 'habitacion', value: 'habitacion', width: 150 },
      { text: 'cama', value: 'cama', width: 150 },
      { text: 'csexo', value: 'csexo', width: 150 },
      { text: 'iniciocontrato', value: 'iniciocontrato', width: 180 },
      { text: 'fincontrato', value: 'fincontrato', width: 180 }
    ],
    empleadosAsignadosCampamento: []
  }),
  methods: {
    openDialogUpload() {
      this.dialogUpload = true;
    },
    closeDialogUpload() {
      this.fileUpload = null;
      this.dialogUpload = false;
    },
    openDialog() {
      this.dialog = true;
    },
    cancelarDialogo() {
      this.dialog = false;
    },
    changeFileUpload($event) {
      this.fileUpload = $event;
    },
    row_classes(item) {
      return { 'color-error': item.error };
    },
    async acceptDialogUpload() {
      if (this.fileUpload === null || this.fileUpload === undefined) return;
      /*this.$papa.parse(this.fileUpload, {
        dynamicTyping: true,
        header: true,
        complete: function(results) {
          console.log(results);
        }
      });
      */
      this.dialogLoading = true;
      let reader = new FileReader();
      reader.onload = async (e) => {
        let data = e.target.result;
        let fixedData = this.fixdata(data);
        let workbook = XLSX.read(btoa(fixedData), { type: 'base64' });
        let firstSheetName = workbook.SheetNames[0];
        let worksheet = workbook.Sheets[firstSheetName];
        const res = XLSX.utils.sheet_to_json(worksheet);
        this.dialogUpload = false;
        await this.asignarEmpleados(res);
        //this.empleadosAsignadosCampamento = res;
        this.dialogLoading = false;
        /*res.forEach((el) => {
          /!*el.iniciocontrato = this.convertDateExcel(el.iniciocontrato);
          el.fincontrato = this.convertDateExcel(el.fincontrato);
          el.fincampamento = this.convertDateExcel(el.fincampamento);
          el.fecha = this.convertDateExcel(el.fecha);*!/

          el.iniciocontrato = moment(this.convertDateExcel(el.iniciocontrato)).format('YYYY-MM-DD');
          el.fincontrato = moment(this.convertDateExcel(el.fincontrato)).format('YYYY-MM-DD');
          el.fincampamento = moment(this.convertDateExcel(el.fincampamento)).format('YYYY-MM-DD h:mm:ss');
          el.fecha = moment(this.convertDateExcel(el.fecha)).format('YYYY-MM-DD');
          el.hora = moment(this.convertDateExcel(el.hora)).format('h:mm:ss');
          return el;
        });*/
      };
      reader.readAsArrayBuffer(this.fileUpload);
    },
    convertDateExcel(fecha) {
      let esExcel = true;
      let diasDesde1900 = esExcel ? 25567 + 1 : 25567;
      return new Date((fecha - diasDesde1900) * 86400 * 1000);

      /*let day = date.getDate();
      let month = date.getMonth() + 1;
      let year = date.getFullYear();

      return `${year.toString()}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;*/
    },
    fixdata(data) {
      var o = '',
        l = 0,
        w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w)));
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
    get_header_row(sheet) {
      var headers = [],
        range = XLSX.utils.decode_range(sheet['!ref']);
      var C,
        R = range.s.r; /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) {
        /* walk every column in the range */
        var cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]; /* find the cell in the first row */
        var hdr = 'UNKNOWN ' + C; // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        headers.push(hdr);
      }
      return headers;
    },
    workbook_to_json(workbook) {
      var result = {};
      workbook.SheetNames.forEach(function(sheetName) {
        var roa = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
        if (roa.length > 0) {
          result[sheetName] = roa;
        }
      });
      return result;
    },
    async asignarEmpleados(val) {
      this.cancelarDialogo();
      this.dialogLoading = true;
      this.empleadosAsignadosCampamento = [];

      const listEmployees = val;
      const listPlan = [];

      val.forEach((el) => {
        listPlan.push(el.planillatrabajador.trim());
      });

      const listPlanilla = new Set(listPlan);

      const listDistribution = await this.asignacionService.get().execResource('predistribucion', {
        idempresa: localStorage.getItem('emp'),
        idplanilla: [...listPlanilla].join(',')
      });

      for (const employee of listEmployees) {
        for (const distribution of listDistribution) {
          if (
            employee.sexo === distribution.sexounid &&
            employee.planillatrabajador === distribution.idplanilla &&
            parseInt(distribution.activo) === 1
          ) {
            this.empleadosAsignadosCampamento.push({
              idunidadcampamento: distribution.idunidadcampamento,
              idtrabajador: employee.idtrabajador,
              nombres: employee.nombresall,
              sexo: employee.sexo,
              tipocampamento: distribution.idtipocampamento,
              sectorpadre: distribution.idsectorpadre,
              sector: distribution.idsector,
              aldea: distribution.aldea,
              carpa: distribution.carpa,
              habitacion: distribution.habitacion,
              cama: distribution.cama,
              csexo: distribution.sexounid,
              iniciocontrato: employee.iniciocontrato,
              fincontrato: employee.fincontrato,
              idempresa: employee.idempresa,
              idasistenciafipe: employee.idasistencia,
              periodo: employee.periodo,
              idplanilla: employee.planillatrabajador,
              diascontrato: employee.diascontrato,
              fincampamento: employee.fincampamento,
              idusuariofipe: employee.idusuarioaprobador,
              fecha: employee.fecha,
              hora: employee.hora,
              error: false
            });

            const i = listDistribution.indexOf(distribution);

            if (i !== -1) {
              listDistribution.splice(i, 1);
            }
            break;
          }
        }
      }
      this.dialogLoading = false;
    },
    deleteDuplicados() {
      this.empleadosAsignadosCampamento = this.empleadosAsignadosCampamento.filter((el) => el.error === false);
      this.showEliminar = false;
    },
    cancelar() {
      this.$router.push({ path: '/campamento/asignacion' });
    },
    async guardar() {
      if (this.empleadosAsignadosCampamento.length <= 0) return;
      const res = await this.asignacionService.post().execResource('asignardistribucion', {
        exportacion: [...this.empleadosAsignadosCampamento]
      });

      if (res.status) {
        this.showEliminar = false;
        this.text = res.message;
        this.snackbar = true;
        this.empleadosAsignadosCampamento = [];
        this.$refs.empleadolista.empleadosSelect = [];
      } else {
        this.showEliminar = true;

        this.empleadosAsignadosCampamento.map((element) => {
          element.error = false;
          return element;
        });
        for (const el of res.message) {
          this.empleadosAsignadosCampamento.map((element) => {
            if (el.idtrabajador === element.idtrabajador) {
              element.error = true;
            }
            return element;
          });
        }
        this.text = 'Error en datos duplicados';
        this.snackbar = true;
      }
    }
  },
  async mounted() {
    this.asignacionService = this.$httpService(new AsignacionService(), this);
  }
};
</script>
